// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file src/protos/catalogs/catalog.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file src/protos/catalogs/catalog.proto.
 */
export const file_src_protos_catalogs_catalog: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty]);

/**
 * Countries
 *
 * @generated from message CountryDto
 */
export type CountryDto = Message<"CountryDto"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string alpha2 = 2;
   */
  alpha2: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message CountryDto.
 * Use `create(CountryDtoSchema)` to create a new message.
 */
export const CountryDtoSchema: GenMessage<CountryDto> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 0);

/**
 * @generated from message CountryResponse
 */
export type CountryResponse = Message<"CountryResponse"> & {
  /**
   * @generated from field: repeated CountryDto countries = 1;
   */
  countries: CountryDto[];

  /**
   * @generated from field: optional string code = 2;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 3;
   */
  message?: string;
};

/**
 * Describes the message CountryResponse.
 * Use `create(CountryResponseSchema)` to create a new message.
 */
export const CountryResponseSchema: GenMessage<CountryResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 1);

/**
 * @generated from message AdminDivision1Dto
 */
export type AdminDivision1Dto = Message<"AdminDivision1Dto"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message AdminDivision1Dto.
 * Use `create(AdminDivision1DtoSchema)` to create a new message.
 */
export const AdminDivision1DtoSchema: GenMessage<AdminDivision1Dto> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 2);

/**
 * @generated from message AdminDivision1Request
 */
export type AdminDivision1Request = Message<"AdminDivision1Request"> & {
  /**
   * @generated from field: int32 countryId = 1;
   */
  countryId: number;
};

/**
 * Describes the message AdminDivision1Request.
 * Use `create(AdminDivision1RequestSchema)` to create a new message.
 */
export const AdminDivision1RequestSchema: GenMessage<AdminDivision1Request> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 3);

/**
 * @generated from message AdminDivision1Response
 */
export type AdminDivision1Response = Message<"AdminDivision1Response"> & {
  /**
   * @generated from field: repeated AdminDivision1Dto adminDivisions1 = 1;
   */
  adminDivisions1: AdminDivision1Dto[];

  /**
   * @generated from field: optional string code = 2;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 3;
   */
  message?: string;
};

/**
 * Describes the message AdminDivision1Response.
 * Use `create(AdminDivision1ResponseSchema)` to create a new message.
 */
export const AdminDivision1ResponseSchema: GenMessage<AdminDivision1Response> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 4);

/**
 * @generated from message AdminDivision2Dto
 */
export type AdminDivision2Dto = Message<"AdminDivision2Dto"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message AdminDivision2Dto.
 * Use `create(AdminDivision2DtoSchema)` to create a new message.
 */
export const AdminDivision2DtoSchema: GenMessage<AdminDivision2Dto> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 5);

/**
 * @generated from message AdminDivision2Request
 */
export type AdminDivision2Request = Message<"AdminDivision2Request"> & {
  /**
   * @generated from field: int32 admin1Id = 1;
   */
  admin1Id: number;
};

/**
 * Describes the message AdminDivision2Request.
 * Use `create(AdminDivision2RequestSchema)` to create a new message.
 */
export const AdminDivision2RequestSchema: GenMessage<AdminDivision2Request> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 6);

/**
 * @generated from message AdminDivision2Response
 */
export type AdminDivision2Response = Message<"AdminDivision2Response"> & {
  /**
   * @generated from field: repeated AdminDivision2Dto adminDivisions2 = 1;
   */
  adminDivisions2: AdminDivision2Dto[];

  /**
   * @generated from field: optional string code = 2;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 3;
   */
  message?: string;
};

/**
 * Describes the message AdminDivision2Response.
 * Use `create(AdminDivision2ResponseSchema)` to create a new message.
 */
export const AdminDivision2ResponseSchema: GenMessage<AdminDivision2Response> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 7);

/**
 * @generated from message LocalityDto
 */
export type LocalityDto = Message<"LocalityDto"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message LocalityDto.
 * Use `create(LocalityDtoSchema)` to create a new message.
 */
export const LocalityDtoSchema: GenMessage<LocalityDto> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 8);

/**
 * @generated from message LocalityRequest
 */
export type LocalityRequest = Message<"LocalityRequest"> & {
  /**
   * @generated from field: int32 admin2Id = 1;
   */
  admin2Id: number;
};

/**
 * Describes the message LocalityRequest.
 * Use `create(LocalityRequestSchema)` to create a new message.
 */
export const LocalityRequestSchema: GenMessage<LocalityRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 9);

/**
 * @generated from message LocalityResponse
 */
export type LocalityResponse = Message<"LocalityResponse"> & {
  /**
   * @generated from field: repeated LocalityDto localities = 1;
   */
  localities: LocalityDto[];

  /**
   * @generated from field: optional string code = 2;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 3;
   */
  message?: string;
};

/**
 * Describes the message LocalityResponse.
 * Use `create(LocalityResponseSchema)` to create a new message.
 */
export const LocalityResponseSchema: GenMessage<LocalityResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 10);

/**
 * @generated from message NeighborhoodDto
 */
export type NeighborhoodDto = Message<"NeighborhoodDto"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message NeighborhoodDto.
 * Use `create(NeighborhoodDtoSchema)` to create a new message.
 */
export const NeighborhoodDtoSchema: GenMessage<NeighborhoodDto> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 11);

/**
 * @generated from message NeighborhoodRequest
 */
export type NeighborhoodRequest = Message<"NeighborhoodRequest"> & {
  /**
   * @generated from field: int32 admin2Id = 1;
   */
  admin2Id: number;
};

/**
 * Describes the message NeighborhoodRequest.
 * Use `create(NeighborhoodRequestSchema)` to create a new message.
 */
export const NeighborhoodRequestSchema: GenMessage<NeighborhoodRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 12);

/**
 * @generated from message NeighborhoodResponse
 */
export type NeighborhoodResponse = Message<"NeighborhoodResponse"> & {
  /**
   * @generated from field: repeated NeighborhoodDto neighborhoods = 1;
   */
  neighborhoods: NeighborhoodDto[];

  /**
   * @generated from field: optional string code = 2;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 3;
   */
  message?: string;
};

/**
 * Describes the message NeighborhoodResponse.
 * Use `create(NeighborhoodResponseSchema)` to create a new message.
 */
export const NeighborhoodResponseSchema: GenMessage<NeighborhoodResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 13);

/**
 * @generated from message AutocompleteRequest
 */
export type AutocompleteRequest = Message<"AutocompleteRequest"> & {
  /**
   * @generated from field: string postalCode = 1;
   */
  postalCode: string;
};

/**
 * Describes the message AutocompleteRequest.
 * Use `create(AutocompleteRequestSchema)` to create a new message.
 */
export const AutocompleteRequestSchema: GenMessage<AutocompleteRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 14);

/**
 * @generated from message AutocompleteResponse
 */
export type AutocompleteResponse = Message<"AutocompleteResponse"> & {
  /**
   * @generated from field: int32 countryId = 1;
   */
  countryId: number;

  /**
   * @generated from field: string countryName = 2;
   */
  countryName: string;

  /**
   * @generated from field: int32 admin1Id = 3;
   */
  admin1Id: number;

  /**
   * @generated from field: string admin1Name = 4;
   */
  admin1Name: string;

  /**
   * @generated from field: int32 admin2Id = 5;
   */
  admin2Id: number;

  /**
   * @generated from field: string admin2Name = 6;
   */
  admin2Name: string;

  /**
   * @generated from field: repeated NeighborhoodDto neighborhoods = 7;
   */
  neighborhoods: NeighborhoodDto[];
};

/**
 * Describes the message AutocompleteResponse.
 * Use `create(AutocompleteResponseSchema)` to create a new message.
 */
export const AutocompleteResponseSchema: GenMessage<AutocompleteResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 15);

/**
 * @generated from message ValidateAdministrativePathRequest
 */
export type ValidateAdministrativePathRequest = Message<"ValidateAdministrativePathRequest"> & {
  /**
   * @generated from field: int32 countryId = 1;
   */
  countryId: number;

  /**
   * @generated from field: int32 admin1Id = 2;
   */
  admin1Id: number;

  /**
   * @generated from field: int32 admin2Id = 3;
   */
  admin2Id: number;

  /**
   * @generated from field: int32 cityId = 4;
   */
  cityId: number;

  /**
   * @generated from field: int32 localityId = 5;
   */
  localityId: number;

  /**
   * @generated from field: int32 neighborhoodId = 6;
   */
  neighborhoodId: number;
};

/**
 * Describes the message ValidateAdministrativePathRequest.
 * Use `create(ValidateAdministrativePathRequestSchema)` to create a new message.
 */
export const ValidateAdministrativePathRequestSchema: GenMessage<ValidateAdministrativePathRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 16);

/**
 * @generated from message ValidateAdministrativePathResponse
 */
export type ValidateAdministrativePathResponse = Message<"ValidateAdministrativePathResponse"> & {
  /**
   * @generated from field: bool isValid = 1;
   */
  isValid: boolean;

  /**
   * @generated from field: optional string code = 2;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 3;
   */
  message?: string;
};

/**
 * Describes the message ValidateAdministrativePathResponse.
 * Use `create(ValidateAdministrativePathResponseSchema)` to create a new message.
 */
export const ValidateAdministrativePathResponseSchema: GenMessage<ValidateAdministrativePathResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 17);

/**
 * @generated from message GenderDto
 */
export type GenderDto = Message<"GenderDto"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message GenderDto.
 * Use `create(GenderDtoSchema)` to create a new message.
 */
export const GenderDtoSchema: GenMessage<GenderDto> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 18);

/**
 * @generated from message GenderResponse
 */
export type GenderResponse = Message<"GenderResponse"> & {
  /**
   * @generated from field: repeated GenderDto genders = 1;
   */
  genders: GenderDto[];

  /**
   * @generated from field: optional string code = 2;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 3;
   */
  message?: string;
};

/**
 * Describes the message GenderResponse.
 * Use `create(GenderResponseSchema)` to create a new message.
 */
export const GenderResponseSchema: GenMessage<GenderResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 19);

/**
 * @generated from message AddressesNamesRequest
 */
export type AddressesNamesRequest = Message<"AddressesNamesRequest"> & {
  /**
   * @generated from field: optional int32 countryId = 1;
   */
  countryId?: number;

  /**
   * @generated from field: optional int32 admin1Id = 2;
   */
  admin1Id?: number;

  /**
   * @generated from field: optional int32 admin2Id = 3;
   */
  admin2Id?: number;

  /**
   * @generated from field: optional int32 cityId = 4;
   */
  cityId?: number;

  /**
   * @generated from field: optional int32 localityId = 5;
   */
  localityId?: number;

  /**
   * @generated from field: optional int32 neighborhoodId = 6;
   */
  neighborhoodId?: number;
};

/**
 * Describes the message AddressesNamesRequest.
 * Use `create(AddressesNamesRequestSchema)` to create a new message.
 */
export const AddressesNamesRequestSchema: GenMessage<AddressesNamesRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 20);

/**
 * @generated from message AddressesNamesResponse
 */
export type AddressesNamesResponse = Message<"AddressesNamesResponse"> & {
  /**
   * @generated from field: optional string countryName = 1;
   */
  countryName?: string;

  /**
   * @generated from field: optional string admin1Name = 2;
   */
  admin1Name?: string;

  /**
   * @generated from field: optional string admin2Name = 3;
   */
  admin2Name?: string;

  /**
   * @generated from field: optional string cityName = 4;
   */
  cityName?: string;

  /**
   * @generated from field: optional string localityName = 5;
   */
  localityName?: string;

  /**
   * @generated from field: optional string neighborhoodName = 6;
   */
  neighborhoodName?: string;

  /**
   * @generated from field: optional string code = 7;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 8;
   */
  message?: string;
};

/**
 * Describes the message AddressesNamesResponse.
 * Use `create(AddressesNamesResponseSchema)` to create a new message.
 */
export const AddressesNamesResponseSchema: GenMessage<AddressesNamesResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_catalogs_catalog, 21);

/**
 * @generated from service CatalogData
 */
export const CatalogData: GenService<{
  /**
   * @generated from rpc CatalogData.GetAllCountries
   */
  getAllCountries: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof CountryResponseSchema;
  },
  /**
   * @generated from rpc CatalogData.AdminDivisionsByCountryId
   */
  adminDivisionsByCountryId: {
    methodKind: "unary";
    input: typeof AdminDivision1RequestSchema;
    output: typeof AdminDivision1ResponseSchema;
  },
  /**
   * @generated from rpc CatalogData.AdminDivisions2ByAdmin1Id
   */
  adminDivisions2ByAdmin1Id: {
    methodKind: "unary";
    input: typeof AdminDivision2RequestSchema;
    output: typeof AdminDivision2ResponseSchema;
  },
  /**
   * @generated from rpc CatalogData.LocalitiesByAdmin2Id
   */
  localitiesByAdmin2Id: {
    methodKind: "unary";
    input: typeof LocalityRequestSchema;
    output: typeof LocalityResponseSchema;
  },
  /**
   * @generated from rpc CatalogData.NeighborhoodsByAdmin2Id
   */
  neighborhoodsByAdmin2Id: {
    methodKind: "unary";
    input: typeof NeighborhoodRequestSchema;
    output: typeof NeighborhoodResponseSchema;
  },
  /**
   * @generated from rpc CatalogData.AutocompleteAddressByPostalCode
   */
  autocompleteAddressByPostalCode: {
    methodKind: "unary";
    input: typeof AutocompleteRequestSchema;
    output: typeof AutocompleteResponseSchema;
  },
  /**
   * @generated from rpc CatalogData.ValidateAdministrativePath
   */
  validateAdministrativePath: {
    methodKind: "unary";
    input: typeof ValidateAdministrativePathRequestSchema;
    output: typeof ValidateAdministrativePathResponseSchema;
  },
  /**
   * @generated from rpc CatalogData.GetAllGenders
   */
  getAllGenders: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GenderResponseSchema;
  },
  /**
   * @generated from rpc CatalogData.GetAddressesNames
   */
  getAddressesNames: {
    methodKind: "unary";
    input: typeof AddressesNamesRequestSchema;
    output: typeof AddressesNamesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_src_protos_catalogs_catalog, 0);

